import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as memberActions from 'member-actions'

const propTypes = {
  children: PropTypes.node,
  setResetShoppingCart: PropTypes.func.isRequired,
  to: PropTypes.string.isRequired,
}

function UpgradeButton({ children, setResetShoppingCart, to, ...rest }) {
  const history = useHistory()
  return (
    <button
      onClick={() => {
        setResetShoppingCart(true)
        history.push(to)
      }}
      {...rest}
    >
      {children}
    </button>
  )
}

UpgradeButton.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {
  setResetShoppingCart: memberActions.setResetShoppingCart,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  UpgradeButton
)
